<ng-container>
	<base-display #display [alignment]="getAlignment()" [smallLetters]="s()" [bigLetters]="b()" [unit]="unit()"></base-display>
</ng-container>